<template>
  <div>
    <div class="login-wrap">
      <img src="../assets/fdi/fdi_logo2.jpg" alt="" class="login-logo" />
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <h3 class="title">展商登录 Exhibitor Login</h3>
        <el-form-item prop="username">
          <el-input
            type="text"
            v-model="ruleForm.username"
            auto-complete="off"
            placeholder="账号 Account"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            auto-complete="off"
            placeholder="密码 Password"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="verify_code"
          v-if="login_way == 2"
          class="verifycode"
        >
          <el-input
            type="text"
            v-model="ruleForm.verify_code"
            auto-complete="off"
            placeholder="验证码 CAPTCHA"
          ></el-input>
          <img @click="getVerificationCode" :src="captchaCodeBase64" alt="" />
        </el-form-item>
        <el-form-item prop="sms_code" v-if="login_way == 2" class="smscode">
          <el-input
            v-model="ruleForm.sms_code"
            auto-complete="off"
            placeholder="短信验证码 SMSCode"
          ></el-input>
          <div class="sms_code_button" @click="sendCode">
            {{ isCountdown ? countdown : "获取验证码\ngetSMSCode" }}
          </div>
        </el-form-item>
        <div class="bottom_box">
          <el-checkbox class="remember" v-model="rememberpwd"
            >记住密码 Remember Password</el-checkbox
          >
        </div>
        <el-form-item style="width: 100%">
          <el-button
            type="primary"
            style="width: 100%"
            @click="submitForm('ruleForm')"
            :loading="logining"
            >登录 Login</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span class="dialog_box">忘记密码请联系：010-68512208</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false" size="medium"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import {
  userLogin,
  getLocationTree,
  getmyMenu,
  menuSwitch,
  getCaptchaCode,
  getLoginWay,
  sendSMSCode,
} from "@/api/api";
import { setCookie, getCookie, delCookie } from "../utils/util";
export default {
  name: "login",
  data() {
    return {
      dialogVisible: false,
      //定义loading默认为false
      login_way: 0,
      logining: false,
      // 记住密码
      rememberpwd: false,
      ruleForm: {
        //username和password默认为空
        username: "",
        password: "",
        verify_code: "",
        sms_code: "",
      },
      //rules前端验证
      rules: {
        username: [
          {
            required: true,
            message: "请输入账号 / Please Enter Your Account",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码 / Please Enter Your Password",
            trigger: "blur",
          },
        ],
        // verify_code: [
        //   {
        //     required: true,
        //     message: "请输入验证码 / Please Enter The Verification Code",
        //     trigger: "blur",
        //   },
        // ],
        sms_code: [
          {
            required: true,
            message: "请输入短信验证码 / Please Enter The SMS Code",
            trigger: "blur",
          },
        ],
      },
      captchaCodeBase64: "",
      countdown: 60,
      isCountdown: false,
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取存在本地的用户名密码
    this.getuserpwd();
    this.getWay();
  },
  // 里面的函数只有调用才会执行
  methods: {
    async getWay() {
      const res = await getLoginWay();
      if (res.data.code == 1) {
        this.login_way = res.data.data.login_way;
        if (this.login_way == 2) {
          this.getVerificationCode();
        }
      } else {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: "获取登录方式失败！<br>Failed to retrieve login method！",
        });
      }
    },
    async getVerificationCode() {
      const res = await getCaptchaCode();
      if (res.data.code == 1) {
        this.captchaCodeBase64 = res.data.data.img;
      } else {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: "获取图形验证码失败！<br>Failed to retrieve SMS code！",
        });
      }
    },
    async sendCode() {
      if (this.isCountdown) {
        return false;
      }
      let username = this.ruleForm.username.trim();
      if (username === "") {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: "请输入登录账号！<br>Please Enter The Account！",
        });
        return false;
      }
      let captcha = this.ruleForm.verify_code.trim();
      if (captcha === "") {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: "请输入图形验证码！<br>Please Enter The Captcha！",
        });
        return false;
      }
      const res = await sendSMSCode({
        username: username,
        verify_code: captcha,
      });
      if (res.data.code == 1) {
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message:
            "短信验证码已发送！<br>The SMS verification code has been sent！",
        });
        this.isCountdown = true;
        this.countdownTimer();
      } else {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: "请输入短信验证码！<br>Please Enter The SMS Code！",
        });
      }
    },

    open() {
      this.dialogVisible = true;
    },

    // 获取用户名密码
    getuserpwd() {
      if (getCookie("user") != "" && getCookie("pwd") != "") {
        this.ruleForm.username = getCookie("user");
        this.ruleForm.password = getCookie("pwd");
        this.rememberpwd = true;
      }
    },

    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.logining = true;
          localStorage.removeItem("Flag");
          var reqParam = {
            username: this.ruleForm.username,
            password: this.ruleForm.password,
            sms_code: this.ruleForm.sms_code,
          };
          userLogin(reqParam)
            .then((res) => {
              if (res.data.code == 1) {
                let loginRes = {
                  token: res.data.data.token,
                  isLogin: true,
                };
                this.$store.commit("userStatus", loginRes);
                localStorage.setItem("Flag", "isLogin");
                if (this.rememberpwd) {
                  //保存帐号到cookie，有效期7天
                  setCookie("user", this.ruleForm.username, 7);
                  //保存密码到cookie，有效期7天
                  setCookie("pwd", this.ruleForm.password, 7);
                } else {
                  delCookie("user");
                  delCookie("pwd");
                }
                // this.getmenuSwitch();
                // this.getLocationTree();
                this.getmyMenu();
                // 缓存token 用户个人信息
                localStorage.setItem("userdata", JSON.stringify(res.data.data));
              } else {
                this.$message.warning(res.data.msg);
                this.logining = false;
                return false;
              }
            })
            .catch((err) => {
              this.logining = false;
            });
        } else {
          this.$message.error(
            "请输入用户名密码 / Please Enter The Account And Password"
          );
          this.logining = false;
          return false;
        }
      });
    },
    getmenuSwitch() {
      menuSwitch()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            //如果请求成功就让他2秒跳转路由
            setTimeout(() => {
              this.logining = false;
              if (data.menu_switch == "NHNE") {
                this.$router.push({
                  path: "/discussionindex",
                });
              } else {
                this.$router.push({
                  path: "/index",
                });
              }
            }, 1000);
            this.$store.commit("menu_switch", data.menu_switch);
            sessionStorage.setItem("menu_switch", data.menu_switch);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取左侧菜单
    getmyMenu() {
      getmyMenu()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            this.$store.commit("menuStatus", JSON.stringify(data));
            localStorage.setItem("menu", JSON.stringify(data));
            localStorage.setItem("language", "cn");
            this.$router.push({
              path: "/index",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取国家
    getLocationTree() {
      getLocationTree({})
        .then((res) => {
          if (res.data.code == 1) {
            localStorage.setItem("locationdata", JSON.stringify(res.data.data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFlag(form) {
      if (form.username.length > 0) {
        let data = {
          account: this.ruleForm.username,
        };
        SafeLogin_send_pcode(data).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.timer();
          } else {
          }
        });
        // }
      } else {
        this.$message.error("请填写账号");
      }
    },
    countdownTimer() {
      let timer = setInterval(() => {
        if (this.countdown === 0) {
          this.isCountdown = false;
          this.countdown = 60;
          clearInterval(timer);
          return false;
        }
        this.countdown -= 1;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
/*/deep/ .el-dialog__wrapper{*/
/*z-index: 2005 !important;*/
/*}*/
/deep/ .el-dialog {
  margin-top: 30vh !important;
}
/deep/ .el-button--primary,
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #fc933f;
  border-color: #fc933f;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #fc933f;
}
.dialog_box {
  font-size: 16px;
  font-weight: bold;
}
.login-wrap {
  width: 100%;
  height: 100%;
  position: fixed;

  background-image: url("../assets/loginbg.jpg");
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;
  .login-logo {
    width: 196px;
    height: 74px;
    position: absolute;
    top: 100px;
    left: 160px;
  }
}
.login-container {
  border-radius: 10px;
  margin: 0px auto;
  width: 350px;
  padding: 30px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  text-align: left;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 50%;
  left: 64%;
  transform: translateY(-50%);
}
.verifycode {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: flex-start;
    .el-input {
      width: 60%;
      margin-right: 10%;
    }
    img {
      height: 40px;
      width: 30%;
      cursor: pointer;
    }
  }
}
.smscode {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: flex-start;
    .el-input {
      width: 60%;
      margin-right: 10%;
    }
    .sms_code_button {
      height: 40px;
      width: 30%;
      cursor: pointer;
      box-sizing: border-box;
      border: 1px solid #ccc;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: grey;
      border-radius: 4px;
    }
  }
}
.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}
.remember {
  margin: 10px 0px 35px 0px;
}
.code-box {
  text-align: right;
}
.codeimg {
  height: 40px;
}
.bottom_box {
  display: flex;
  justify-content: space-between;
}
.wjpass {
  color: #666;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #666;
}
@media only screen and (max-width: 767px) {
  .login-wrap {
    display: flex;
    align-items: center;
    background-size: 100%;
  }
  .login-container {
    width: 70%;
  }
}
</style>